import { color as foundationColor, font, size } from '../foundation';

const { neutral, primary, success } = foundationColor;

export const stepper = {
  size: {
    sm: {
      button: size[700],
      fontSize: font.size[88],
    },
    lg: {
      button: size[900],
      fontSize: font.size[125],
    },
  },
  color: {
    button: {
      bg: {
        inactive: neutral[400],
        active: primary[600],
        completed: success[600],
      },
      border: {
        active: primary[200],
      },
    },
    label: {
      active: primary[700],
      completed: success[800],
    },
    connector: {
      inactive: neutral[400],
      active: primary[600],
      completed: success[600],
    },
  },
  summary: {
    bg: {
      active: neutral[200],
    },
  },
};

export default stepper;
